import React, { useContext, useEffect } from "react";
import {
  Box,
  Dialog,
  DialogContent,
  TextField,
  Button,
  Typography,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { isEmail } from "class-validator";
// import AddUserImg from "../../assets/users/adduser.png";
import Logo from "../../assets/logo/logo.svg";
import LogoDark from "../../assets/logo/logo_dark.svg";
import { ThemeContext } from "../../context/ThemeContext";

const AddUserDialog = ({ open, setOpen, role, onAddUser }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset, // Using reset here to clear the form fields
  } = useForm({
    defaultValues: {
      username: "",
      email: "",
      password: "",
      description: "",
    },
  });

  const { darkMode } = useContext(ThemeContext);

  const onSubmit = (data) => {
    onAddUser(data); // Add the new user
  };

  // Reset form values when the dialog opens (open prop changes)
  useEffect(() => {
    if (open) {
      reset({
        username: "",
        email: "",
        password: "",
        description: "",
      });
    }
  }, [open, reset]); // Only trigger when dialog opens

  return (
    <Dialog open={open} maxWidth="sm" fullWidth onClose={() => setOpen(false)}>
      <DialogContent
        sx={{
          px: 0,
          py: 0,
          mb: 0,
        }}
      >
        <Box
          sx={{
            padding: 3,
          }}
        >
          <Box display={"flex"} justifyContent={"center"} sx={{ mt: 1, mb: 2 }}>
            <img src={darkMode ? LogoDark : Logo} alt="3D Practice Logo" />
          </Box>
          <Typography
            sx={{
              fontFamily: "Poppins",
              fontSize: "40px",
              fontWeight: 500,
              textAlign: "center",
              mb: 1,
            }}
          >
            Add {role === "Admin" ? "Administrator" : "User"}
          </Typography>
          <form
            onSubmit={handleSubmit(onSubmit)}
            style={{
              display: "flex",
              flexDirection: "column",
              flexGrow: 1,
              justifyContent: "space-between",
            }}
          >
            <TextField
              fullWidth
              variant="filled"
              label="Username"
              placeholder="Enter your Username"
              error={!!errors.username}
              helperText={errors.username?.message}
              {...register("username", { required: "Username is required" })}
              margin="normal"
            />

            <TextField
              fullWidth
              variant="filled"
              label="Password"
              type="password"
              placeholder="Enter your Password"
              error={!!errors.password}
              helperText={errors.password?.message}
              {...register("password", {
                required: "Password is required",
              })}
              margin="normal"
            />

            <TextField
              fullWidth
              variant="filled"
              label="Email"
              placeholder="Enter your Email"
              error={!!errors.email}
              helperText={errors.email?.message}
              {...register("email", {
                required: "Email is required",
                validate: (value) =>
                  isEmail(value) || "Please enter a valid email address",
              })}
              margin="normal"
            />

            <TextField
              fullWidth
              variant="filled"
              multiline
              rows={4}
              label="Description"
              placeholder="Enter your Description"
              error={!!errors.description}
              helperText={errors.description?.message}
              {...register("description", {
                required: "Description is required",
              })}
              margin="normal"
            />

            <Box display={"flex"} justifyContent={"flex-end"} sx={{ mt: 3 }}>
              <Button
                type="submit"
                variant="contained"
                sx={{
                  width: "100%",
                  fontFamily: "Poppins",
                  fontSize: "18px",
                  fontWeight: 600,
                  px: 5,
                  py: 1,
                }}
              >
                Add
              </Button>
            </Box>
          </form>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default AddUserDialog;
